module.exports = __webpack_public_path__ + "img/roadmap-phase-2-cell-2-icon.b18a38fc.png";